/**
 * Fügt zu einer instanceToPatch alle in literalWithMethods definierten Methoden oder Werte hinzu,
 * falls diese nicht schon existieren
 * @param {any} instanceToPatch
 * @param {Object} literalWithMethods
 */
export function monkeyPatch(instanceToPatch: any, literalWithMethods: any): void {
  Object.keys(literalWithMethods)
    .filter((key) => typeof instanceToPatch[key] === "undefined")
    .forEach((key) => (instanceToPatch[key] = literalWithMethods[key]));
}

/**
 * Überschreibt Methoden und Werte in instanceToPatch
 * @param instanceToPatch
 * @param literalWithMethods
 */
export function forcePatch(instanceToPatch: any, literalWithMethods: any): void {
  Object.keys(literalWithMethods).forEach(
    (key) => (instanceToPatch[key] = literalWithMethods[key]),
  );
}
